/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';
import { EMPLOYEE_ROLES } from 'config/constants';

const RoleSelect = ({ className, ...props }) =>
  <ReactSelect
    name="role"
    className={cx(reactSelectStyles, className)}
    label="Roles"
    options={EMPLOYEE_ROLES}
    {...props}
  />;


RoleSelect.defaultProps = {
  resetValue: '',
  placeholder: 'Select A Role',
};

RoleSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
  className: PropTypes.string,
  multi: PropTypes.bool,
  resetValue: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  placeholder: PropTypes.string,
};

export default RoleSelect;



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/RoleSelect/index.jsx